import Swal from 'sweetalert2';
<template>
   <v-app class="fill-height">
<v-card width="1024" class="my-auto mx-auto">
      <v-img 
      
         src="/images/1.png" width="1024"  flat class="mx-auto my-auto pb-16 black ">
         <v-container class="mx-auto" >
            <v-row  class="d-flex flex-column align-content-md-center mx-auto ">
               <v-img width="456"  class="my-n3  mx-auto" 
                src="/images/creditcard-2-md.png">


               </v-img>
               <v-row class="d-flex align-center mx-auto pr-0">
                  <v-col>
                     <h5 class="font-weight-bold font-italic white--text pr-0" style="color: #FFF;
                     font-family: Cabin !important;
                     font-size: 21.075px;
                     font-style: italic;
                     font-weight: 700;
                     line-height: 31.613px; /* 150% */
                     letter-spacing: 0.659px;">
                        Preventa</h5>

                  </v-col>
                  <v-col>
                     <h2 class="font-weight-black font-italic white--text " style="color: #FFF;
                     font-family: Montserrat;
                     font-size: 31.613px;
                     font-style: italic;
                     font-weight: 900;
                     line-height: 62.101px; /* 196.443% */
                     letter-spacing: 5.269px;">
                        Exclusiva
                     </h2>

                  </v-col>
                 


               </v-row>
               <v-row>
                  <p class="onPrimary--text  caption mx-auto mt-n6">
                     TicketShop y Mastercard te traen a tu artista favorito.
                  </p>
               </v-row>

               <v-col cols="12" class="text-center">
                  <h6 class="onPrimary--text font-weight-medium">
                     Ingrese los seis primeros digitos de su tarjeta.
                  </h6>
               </v-col>

               <div class="ma-auto pa-0" position-relative style="max-width: 300px">
                  <v-otp-input dark plain v-model="otp" height="36" width="36" :disabled="loading" @finish="onFinish" type="number">
                  </v-otp-input>
                  <v-overlay absolute :value="loading">
                     <v-progress-circular indeterminate color="primary">
                     </v-progress-circular>
                  </v-overlay>
               </div>





               <v-col cols="12" md="4" class="d-flex flex-column pa-md-0 mx-auto">
                  <v-btn class="mt-4 primary--text" depressed color="white" rounded type="submit" height="44px">
                     Cancelar </v-btn>



               </v-col>
            </v-row>
         </v-container>
      </v-img>
   </v-card>
   </v-app>
</template>
<script>

export default {

   data: () => ({
      loading: false,
      otp: '',
      text: '',
      expectedOtp: '133707',
   }),
   methods: {
      onFinish(rsp) {
         this.loading = true
         setTimeout(() => {
            this.loading = false
            swal("Exito", "Tu tarjeta cumple los requisitos", "success");
         }, 2000)
      },
   },
}
</script>
<style scoped>
.position-relative {
   position: relative;
}
</style>